<template>
    <div class="container">
        <HomeHeader />
        <ReportHeader showDate />
        <BgContainer>
            <!-- <div id="move_maker"></div> -->
            <main>
                <div class="title_row" id="move_maker">
                    <!-- <PageTitle title="新闻版块" :isBack="true" /> -->
                    <el-select class="choose_week" placeholder="全部" clearable v-model="week" @change="changeWeek">
                        <el-option v-for="item in weekDict" :key="item.id" :label="item.label" :value="item.id"></el-option>
                    </el-select>
                </div>
                <div class="first_plate">
                    <div class="li" v-for="item in modulars" :key="item" :class="item.tagId === query.tagId1 ? 'active' : ''" @click="query.tagId1 = item.tagId">
                        <div class="con">
                            <h1>{{ item.tagName }}</h1>
                            <h2>{{ item.tagAlias || "-" }}</h2>
                        </div>
                    </div>
                </div>
                <div class="operate_row">
                    <div class="le">
                        <div class="all">
                            <el-checkbox v-model="isAll" :indeterminate="allIndeterminate" @change="allChange">全选</el-checkbox>
                        </div>
                        <div class="item">
                            <span class="label">风险等级：</span>
                            <el-checkbox-group v-model="query.risk" @change="search">
                                <el-checkbox label="high">高风险</el-checkbox>
                                <el-checkbox label="middle">中风险</el-checkbox>
                                <el-checkbox label="low">低风险</el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </div>
                    <div class="ri">
                        <div class="btn" @click="exportExcel">
                            <i class="iconfont icon-xiazai1"></i>
                            <span>导出Excel</span>
                        </div>
                        <div class="btn" @click="openSend">
                            <i class="iconfont icon-fasongyoujian"></i>
                            <span>
                                发送报告
                                <span v-if="checkedList?.length">({{ checkedList.length }})</span>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="second_and_list">
                    <!-- 二级版块 已废弃 -->
                    <div class="second_plate" v-if="false">
                        <div class="all" @click="onAll">全&nbsp;&nbsp;&nbsp;&nbsp;部</div>
                        <div class="li" v-for="item in modularSeconds" :key="item.tagId">
                            <!-- <div class="item_box"
                                :class="item.tagId === query.tagId2 && !item.children?.length ? 'active' : ''"
                                @click.stop="onSecondTag(item)"> -->
                            <div class="item_box" :class="item.tagId === query.tagId2 && !query.tagId3 ? 'active' : ''" @click.stop="onSecondTag(item)">
                                <ArrowDownBold class="arrow" :class="item.isExpand ? 'active' : ''" v-if="item.children?.length" />
                                <h1>{{ item.tagName }}</h1>
                                <span>({{ item.tagTotal }})</span>
                            </div>
                            <!-- <ul :style="{ height: item.isExpand ? item.children.length * 49 + 'px' : '0px' }"> -->
                            <ul :style="{ maxHeight: item.isExpand ? 5000 + 'px' : '0px' }">
                                <li v-for="f in item.children" :key="f.tagId">
                                    <div class="item_box" :class="f.tagId === query.tagId3 ? 'active' : ''" @click.stop="onThirdTag(item, f)">
                                        <h1>{{ f.tagName }}</h1>
                                        <span>({{ f.tagTotal }})</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <!-- 文章列表 -->
                    <div class="list">
                        <ul>
                            <li v-for="item in listData" :key="item.articleId" @click="toDetails(item)">
                                <div class="title">
                                    <el-checkbox class="checkbox" v-model="item.checked" @click.stop @change="(e) => checkedChange(e, item)" />
                                    <h1 v-html="item.articleTitle"></h1>
                                    <RiskChange :artcle="item" @change="(e) => (item.risk = e)">
                                        <div>
                                            <span class="risk_tag high" v-if="item.risk === 'high'">高风险</span>
                                            <span class="risk_tag middle" v-if="item.risk === 'middle'">中风险</span>
                                            <span class="risk_tag low" v-if="item.risk === 'low'">低风险</span>
                                        </div>
                                    </RiskChange>
                                </div>
                                <p v-html="item.description"></p>
                                <div class="info">
                                    <span>{{ item.articleSource }} {{ item.releaseName !== item.articleSource ? `| ${item.releaseName}` : `` }}</span>
                                    <div class="ri">
                                        <span>{{ item.showTime }}</span>
                                        <template v-if="!isShare && !isPreview">
                                            <div class="coll" v-if="!item.favoriteId" @click.stop="openC({ ...item, tagId: $route.query.tagId1 })">
                                                <i class="iconfont icon-shoucang1"></i>
                                            </div>
                                            <div class="coll active" v-else @click.stop="openCancel(item)">
                                                <i class="iconfont icon-shoucang"></i>
                                            </div>
                                            <div class="coll share" @click.stop="openShare(item)">
                                                <i class="iconfont icon-fenxiang"></i>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                                <div class="arrow">
                                    <ArrowRightBold class="icon" />
                                </div>
                            </li>
                        </ul>
                        <div class="page_box" v-if="listData.length">
                            <el-pagination
                                small
                                background
                                layout="prev, pager, next, sizes"
                                class="pagination"
                                :total="total"
                                v-model:current-page="query.pageNum"
                                :page-sizes="[15, 30, 50, 100]"
                                v-model:page-size="query.pageSize"
                                @current-change="setListData"
                                @size-change="handleSizeChange"
                            />
                        </div>
                        <el-empty description="暂无数据" v-if="!listData.length" />
                    </div>
                </div>
            </main>
        </BgContainer>
    </div>
    <!-- 收藏 -->
    <CollectionDialog :show="showC" :art="art" @close="closeC" @success="setListData" />
    <!-- 分享文章 -->
    <ShareDetailsDialog :show="showShare" :row="rowShare" @close="closeShare" />
    <!-- 取消收藏 -->
    <CancelCollDialog :show="showCancel" :row="rowCancel" @close="closeCancel" @success="handleCancelSuccess" />
    <!-- 发送报告 -->
    <SendDialog :show="showSend" :groupDict="groupDict" :articleIdList="checkedList" @close="closeSend" />
</template>

<script>
export default {
    name: "Plate",
};
</script>

<script setup>
import useDict from "./useDict";
import { onBeforeRouteLeave } from "vue-router";
import useKeepAlive from "@/store/useKeepAlive";
import { ref, computed, nextTick, onActivated } from "vue";
import BgContainer from "@/components/customer-week-report/pc/BgContainer.vue";
import ReportHeader from "@/components/customer-week-report/pc/ReportHeader.vue";
import PageTitle from "@/components/customer-week-report/pc/PageTitle.vue";
import ShowYear from "@/components/customer-week-report/pc/ShowYear.vue";
import ShowMonth from "@/components/customer-week-report/pc/ShowMonth.vue";
import { ArrowRightBold, ArrowDownBold } from "@element-plus/icons-vue";
import { useRouter, useRoute } from "vue-router";
import useParams from "./useParams";
import { apiFreeWeeklyArticleList } from "@/request/api";
import cloneDeep from "loadsh";
import { groupBy } from "@/utils";
import { getMmDd } from "@/utils/date";
import HomeHeader from "@/components/common/HomeHeader.vue";
import CollectionDialog from "@/components/collection-dialog/index.vue";
import useCollection from "@/components/collection-dialog/useCollection";
import ShareDetailsDialog from "@/components/share-dialog/details/index.vue";
import useShareDetails from "@/components/share-dialog/details/useShareDetails";
import CancelCollDialog from "@/components/cancel-coll-dialog/index.vue";
import useCancelColl from "@/components/cancel-coll-dialog/useCancelColl";
import useWeek from "./useWeek";
import RiskChange from "@/components/common/RiskChange.vue";
import useExportExcel from "./useExportExcel";
import SendDialog from "./send-dialog/index.vue";
import useSend from "./send-dialog/useSend";

const keepAliveStore = useKeepAlive(); // 缓存const $route = useRoute();
const $route = useRoute();
const $router = useRouter();
defineProps({
    weekDict: { type: Array, default: [] },
});
const total = ref(0);
const listData = ref([]);
const cascaderRef = ref(null); // 时间/周报选择器
const isCascadersShow = ref(true); // 时间/周报选择器是否显示
// 是否是分享
const isShare = computed(() => {
    return !!$route.query.share;
});
// 是否是预览
const isPreview = computed(() => {
    return !!$route.query.previewToken;
});
const isAll = ref(false); // 是否全选
const checkedList = ref([]); // 已选中文章id集合
// 是否半选
const allIndeterminate = computed(() => {
    return listData.value.some((item) => checkedList.value.includes(item.articleId)) && !listData.value.every((item) => checkedList.value.includes(item.articleId));
});

// 字典
const { groupDict } = useDict();

// 周相关
const { weekDict, week, timeRank, changeWeek } = useWeek({
    change: () => {
        setModulars();
        search();
    },
    callback: () => {
        setModulars();
        setListData();
    },
});

// 参数
const { query, modulars, modularSeconds, params, onSecondTag, onThirdTag, onAll, setModulars } = useParams({ search, timeRank });

// 周报选择框change
function handleWeekChange(e = []) {
    // query.year = e[0] || null;
    // query.month = e[1] || null;
    // query.weeklyId = e[2] || "";
    $router.replace({ query: { ...$route.query } });
    setModulars(); // 重新获取版块
    setListData(); // 获取文章列表
    cascaderRef.value.togglePopperVisible();
}

// 周报选择框下拉框显示隐藏监听-关闭下拉框时重新渲染组件，使下一次回显时能正常展开
function handleCascaderShow(e) {
    if (e) return;
    isCascadersShow.value = false;
    nextTick(() => {
        isCascadersShow.value = true;
    });
}

// 回显文章选中状态
function reviewChecked() {
    listData.value = listData.value.map((item) => {
        item.checked = false; // 默认值
        // 已选中时
        if (checkedList.value.includes(item.articleId)) {
            item.checked = true;
        }
        return item;
    });
}

// 获取文章列表
async function setListData() {
    if (!params.value.tagId1) return;
    const { data } = await apiFreeWeeklyArticleList(params.value);
    total.value = data?.total || 0;
    listData.value = data?.list || [];
    // 设置文章选中状态
    reviewChecked();
    // 设置全选默认状态
    setAllChecked();
}

// 搜索
function search() {
    checkedList.value = [];
    query.pageNum = 1;
    setListData();
}

// 分页大小change
function handleSizeChange() {
    query.pageNum = 1;
    setListData();
}

// 单个切换
function checkedChange(e, item) {
    item.checked = e;
    if (e) {
        checkedList.value.push(item.articleId);
    } else {
        checkedList.value = checkedList.value.filter((id) => id !== item.articleId);
    }
    setAllChecked(); // 设置全选默认状态
}

// 全选切换
function allChange(e) {
    isAll.value = e;
    let ids = listData.value.map((item) => item.articleId);
    if (e) {
        checkedList.value = [...new Set([...checkedList.value, ...ids])];
    } else {
        checkedList.value = checkedList.value.filter((id) => !ids.includes(id));
    }
    reviewChecked();
}

// 设置全选默认状态
function setAllChecked() {
    if (listData.value?.length) {
        isAll.value = listData.value.every((item) => checkedList.value.includes(item.articleId));
    } else {
        isAll.value = false;
    }
}

// 收藏
const { show: showC, open: openC, close: closeC, art } = useCollection();

// 取消收藏
const {
    show: showCancel,
    open: openCancel,
    close: closeCancel,
    row: rowCancel,
    handleCancelSuccess,
} = useCancelColl((articleId) => {
    const obj = listData.value.find((item) => item.articleId === articleId);
    obj.favoriteId = null;
});

// 跳转详情
function toDetails(e) {
    const routeQuery = {
        ...$route.query,
        articleId: e.articleId,
        pageNum: query.pageNum,
        pageSize: query.pageSize,
    };
    $router.push({
        path: `/details`,
        query: routeQuery,
    });
}

// 导出
const { exportExcel } = useExportExcel({ params, total });

// 分享
const { show: showShare, row: rowShare, open: openShare, close: closeShare } = useShareDetails();

// 发送报告
const { show: showSend, open: openSend, close: closeSend } = useSend({ checkedList });

// 离开页面时如果时跳转详情页，缓存当前页面，如果不是跳转详情页，不缓存当前页面
onBeforeRouteLeave((to, _from, next) => {
    if (to.name === "Details") {
        keepAliveStore.setKeepRoutes(["Plate"]);
    } else {
        keepAliveStore.setKeepRoutes([]);
    }
    next();
});

// 重新激活页面时刷新列表
onActivated(() => {
    setListData();
});
</script>

<style lang="scss" scoped>
.container {
    background-color: #e6e6e6;
    min-height: calc(100vh - var(--home-header-height));
    padding-top: var(--home-header-height);

    .show_date {
        border-top: 1px solid var(--week-primary-color);
        position: absolute;
        top: 60px;
        right: 44px;
        padding-top: 30px;
        padding-right: 100px;
        padding-left: 10px;
        display: flex;
        align-items: center;
    }

    .small_logo {
        position: absolute;
        top: 87px;
        right: 52px;
    }

    main {
        width: 100%;
        min-height: calc(100vh - var(--week-pc-header-height));
        background-color: #f5f5f5;
        box-shadow: 0 0 20px #ccc;
        padding: 46px 80px;

        .title_row {
            display: flex;
            align-items: center;
            justify-content: flex-end;
        }

        .first_plate {
            display: flex;
            padding-top: 44px;
            justify-content: justify-content;

            .li {
                border-right: 2px solid #cfcfcf;
                text-align: center;
                cursor: pointer;
                padding: 0 40px;

                &:first-child {
                    padding-left: 0;
                }

                &:last-child {
                    border-right: none;
                    padding-right: 0;
                }

                .con {
                    display: inline-block;
                    text-align: left;

                    h1 {
                        font-size: 21px;
                        line-height: 1em;
                        color: #737373;
                    }

                    h2 {
                        font-size: 14px;
                        line-height: 1em;
                        color: var(--week-primary-color);
                        margin-top: 7px;
                    }

                    &::after {
                        display: block;
                        content: "";
                        width: 100%;
                        height: 5px;
                        background-color: #cbcbcb;
                        margin-top: 8px;
                    }
                }

                &.active {
                    .con {
                        h1 {
                            color: #000;
                        }

                        &::after {
                            background-color: var(--week-primary-color);
                        }
                    }
                }
            }
        }

        .operate_row {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 15px 46px;
            padding-left: 23px;
            background-color: #fff;
            margin-top: 30px;
            border-bottom: 1px dashed #cecece;
            .le {
                display: flex;
                align-items: center;
                .all {
                    margin-right: 30px;
                    color: #666;
                }
                .item {
                    display: flex;
                    align-items: center;
                    .label {
                        color: #666;
                        line-height: 1em;
                    }
                }
            }
            .ri {
                display: flex;
                align-items: center;
                .btn {
                    display: flex;
                    align-items: center;
                    color: var(--primary-color);
                    margin-left: 30px;
                    user-select: none;
                    cursor: pointer;
                    .iconfont {
                        margin-right: 4px;
                    }
                }
            }
        }

        .second_and_list {
            display: flex;

            .second_plate {
                --pr: 46px;
                width: calc(149px + var(--pr));
                padding-right: var(--pr);

                .all {
                    line-height: 34px;
                    background-color: var(--week-primary-color);
                    color: #fff;
                    padding-left: 32px;
                    font-size: 20px;
                    font-weight: bold;
                    cursor: pointer;
                }

                .li {
                    .item_box {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        padding-top: 20px;
                        padding-bottom: 10px;
                        padding-left: 8px;
                        position: relative;
                        cursor: pointer;

                        &::after {
                            display: block;
                            content: "";
                            width: 100%;
                            height: 1px;
                            background-color: #cbcbcb;
                            position: absolute;
                            bottom: 0;
                            left: 0;
                        }

                        h1 {
                            font-weight: bold;
                            color: #818181;
                            font-size: 16px;
                        }

                        span {
                            color: #818181;
                            font-size: 14px;
                        }

                        .arrow {
                            width: 1em;
                            height: 1em;
                            position: absolute;
                            left: -14px;
                            color: #818181;
                            transform: rotate(0deg);
                            transition: 0.5s;

                            &.active {
                                transform: rotate(180deg);
                            }
                        }

                        &.active {
                            h1,
                            span {
                                color: #000;
                            }

                            &::after {
                                height: 3px;
                                background-color: var(--week-primary-color);
                            }
                        }
                    }

                    ul {
                        transition: 0.3s;
                        overflow: hidden;

                        li {
                            .item_box {
                                padding-left: 18px;

                                h1 {
                                    font-weight: normal;
                                    font-size: 14px;
                                }

                                &.active {
                                    h1 {
                                        font-weight: bold;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        .list {
            min-height: 800px;
            background-color: #fff;
            flex: 1;
            box-shadow: 2.7px 7.5px 8.19px 0.81px rgba(0, 0, 0, 0.06);
            padding: 0 46px;
            padding-bottom: 33px;

            ul {
                padding-bottom: 50px;

                li {
                    padding-top: 35px;
                    padding-bottom: 24px;
                    border-bottom: 1px solid #cecece;
                    position: relative;
                    padding-right: 54px;
                    cursor: pointer;
                    .title {
                        display: flex;
                        flex-wrap: wrap;
                        position: relative;
                        h1 {
                            font-size: 16px;
                            color: #000;
                            font-family: "SourceHanSansCN-Normal-Alphabetic";
                        }
                        .risk_tag {
                            display: inline-block;
                            height: 16px;
                            line-height: 16px;
                            display: flex;
                            align-items: center;
                            background-color: #ccc;
                            border-radius: 8px;
                            color: #fff;
                            font-size: 12px;
                            padding: 0 8px;
                            margin-top: 4px;
                            margin-left: 4px;
                            cursor: pointer;
                            &.high {
                                background-color: #ff2f00;
                            }
                            &.middle {
                                background-color: #ff8000;
                            }
                            &.low {
                                background-color: #43cf7c;
                            }
                        }
                        .checkbox {
                            position: absolute;
                            left: -22px;
                            top: -3px;
                        }
                    }

                    p {
                        color: #727272;
                        font-size: 12px;
                        margin-top: 20px;
                        line-height: 1.8em;
                    }

                    .info {
                        display: flex;
                        justify-content: space-between;
                        padding-top: 11px;

                        span {
                            font-size: 12px;
                            color: #999;
                        }
                        .ri {
                            display: flex;
                            align-items: center;
                            .coll {
                                margin-left: 16px;
                                cursor: pointer;
                                .iconfont {
                                    color: #999;
                                    font-size: 18px;
                                }
                                &.active {
                                    .iconfont {
                                        color: var(--primary-color);
                                    }
                                }
                            }
                        }
                    }

                    .arrow {
                        width: 18px;
                        height: 18px;
                        background-color: var(--week-primary-color);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        position: absolute;
                        top: 37px;
                        right: 0;

                        .icon {
                            width: 1em;
                            height: 1em;
                            color: #fff;
                        }
                    }

                    &:hover {
                        h1 {
                            text-decoration: underline;
                        }
                    }
                }
            }

            .page_box {
                display: flex;
                align-items: center;
                justify-content: center;

                :deep(.el-pagination .el-pager li) {
                    border-radius: 50%;
                    background-color: #cbcbcb;
                    color: #fff;
                    margin: 0 5px;
                }

                // 上下一页样式修改
                :deep(.el-pagination .btn-prev),
                :deep(.el-pagination .btn-next) {
                    background-color: #cbcbcb;
                    color: #fff;
                }

                // 上下一页不可点时，hover字体颜色修改
                :deep(.el-pagination .btn-prev:not(:disabled):hover),
                :deep(.el-pagination .btn-next:not(:disabled):hover) {
                    color: var(--week-primary-color);
                }

                :deep(.el-pagination.is-background .el-pager li:not(.disabled).active) {
                    background-color: var(--week-primary-color);
                }

                :deep(.el-pagination.is-background .el-pager li:not(.active):hover) {
                    color: var(--week-primary-color);
                }

                :deep(.btn-quicknext) {
                    display: inline-flex;
                    align-items: center;
                }
            }
        }
    }
}
</style>

<style lang="scss">
.choose_week {
    width: 220px;

    .el-input__inner {
        border-color: #b7b7b7 !important;
        border-radius: 0;
        background: none;

        &:focus {
            border-color: #b7b7b7 !important;
        }
    }

    .el-input__suffix {
        background-color: var(--week-primary-color);
        right: 0;
        width: 32px;

        .el-input__suffix-inner {
            width: 100%;

            .el-input__icon {
                width: 100%;
                color: #fff;
            }
        }
    }
}
</style>
